import {
  REQUEST_APPEAL_SUBMIT,
  REQUEST_APPEAL_SUCCESS,
  REQUEST_APPEAL_ERROR,
  REQUEST_APPEAL_ALREADY_REPORTED,
  LOAD_DRAFT_EMPTY
} from '../constants';

const initialState = {
  loading: false
};

const appealDataRequest = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_APPEAL_SUBMIT:
      return {
        ...state,
        loading: true
      };
    case REQUEST_APPEAL_SUCCESS:
    case REQUEST_APPEAL_ERROR:
    case REQUEST_APPEAL_ALREADY_REPORTED:
      return {
        ...state,
        loading: false
      };
    case LOAD_DRAFT_EMPTY:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

export default appealDataRequest;
